module.exports = __webpack_public_path__ + "img/5.01506265.jpg";